import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/resource_categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/customers': {
                params: { filter: 'registered:1' }
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/subscribers': {
                params: { sort: 'created_at:desc' }
            },
            '^/hybrid_batch_requests': {
                params: { sort: 'created_at:desc' }
            },
            '^/event_attendees': {
                params: { sort: 'created_at:desc', filter: 'is_main:1' }
            },
            '^/event_attendee/[0-9]': {
                params: { sort: 'created_at:desc', filter: 'is_main:1', with: 'date,partner,attendees,activities' }
            },
            '^/panel/[0-9]+/fields': {
                params: { per_page: 99999 }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            mp4: ['mp4', 'webm'],
            csv: ['csv'],
            mod: ['mod'],
            dwg: ['dwx', 'dwg'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
